import React, { useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2'
import { Box, Divider, Typography } from '@mui/material'
import { getProjectByName } from '../../../../utils/mergeData';
import { ChartComponent } from '../../../common/chartComponent';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import HighchartsMore from "highcharts/highcharts-more";


HighchartsMore(Highcharts);

interface ChartConfig {
  year: string;
  options: Highcharts.Options;
}

const CarbonCredit = () => {
  const [chartConfigs, setChartConfigs] = useState<ChartConfig[]>([]);

  const selectedProjectStr = localStorage.getItem('selectedProject');
  const selectedProject = selectedProjectStr ? JSON.parse(selectedProjectStr) : null;
  const currentProject = getProjectByName(selectedProject?.project_name);
  const [projectSite] = useState(currentProject ? [currentProject] : []);

  const filterCredit = projectSite[0]?.credits;
  const bufferUnits = filterCredit?.buffer_units;
  const estimatedIssued = filterCredit?.estimated_issued_vcu;

  const chartData = Object.keys(filterCredit?.estimated_issued_vcu || {})
    .filter((key) => key !== "unit") // Exclude the "unit" key
    .map((year) => ({
      name: year,
      value1: filterCredit?.estimated_issued_vcu[year as keyof typeof filterCredit.estimated_retired_vcu] as any,
      value2: filterCredit?.estimated_retired_vcu[year as keyof typeof filterCredit.estimated_retired_vcu] as any,
    }));
  const chartDataBuffer = Object.keys(filterCredit?.buffer_units || {})
    .filter((key) => key !== "unit") // Exclude the "unit" key
    .map((year) => ({
      name: year,
      value1: filterCredit?.buffer_units[year as keyof typeof filterCredit.buffer_units] as any,
      value2: filterCredit?.estimated_issued_vcu[year as keyof typeof filterCredit.estimated_issued_vcu] as any,
    }));

  useEffect(() => {
    const years = Object.keys(bufferUnits || {}).filter((year) => year !== "unit");
    const configs = years.map((year) => ({
      year,
      options: {
        chart: {
          type: "pie",
        },
        title: {
          text: `Year ${year}`,
        },
        plotOptions: {
          pie: {
            innerSize: "50%", // Donut chart
            dataLabels: {
              enabled: true,
              format: "<b>{point.name}</b>: {point.y}",
            },
          },
        },
        series: [
          {
            name: "Credits",
            colorByPoint: true,
            data: [
              { name: "Buffer Units", y: bufferUnits[year as keyof typeof filterCredit.vcu] as any || 0 },
              { name: "Estimated Issued", y: estimatedIssued[year as keyof typeof filterCredit.vcu] as any || 0 },
            ],

          },
        ],
      },
    }));

    setChartConfigs(configs as any);
  }, [bufferUnits, estimatedIssued]);

  return (
    <Box sx={{ mt: 5 }}>
      <Box
        sx={{
          maxHeight: '400px',
          overflowY: 'auto',
          border: '1px solid #ccc',
          padding: '10px',
          backgroundColor: "#fff",
          margin: "15px 1px",
          borderRadius: "8px",
          boxShadow: "0px 0px 5px 0px rgba(0, 0, 0, 0.1019607843) !important",
        }}
      >
        <Grid container spacing={4} sx={{ m: 3 }}>
        <Grid size={{ xs: 4, sm: 2 }}>
            <Typography sx={{ color: "#666666", fontWeight: 600, fontSize: '16px' }}>
              {'Total Estimated VCUs'}
            </Typography>
            <Typography sx={{ color: "#000", fontWeight: 500, fontSize: '20px' }}>
              {projectSite[0]?.credits?.total_estimated_issued_vcu}
            </Typography>
          </Grid>
          <Divider orientation="vertical" flexItem sx={{ mx: 2, borderColor: '#ccc' }} />
          <Grid size={{ xs: 4, sm: 3 }}>
            <Typography sx={{ color: "#666666", fontWeight: 600, fontSize: '16px' }}>
              {'Average Price Per VCU'}
            </Typography>
            <Typography sx={{ color: "#000", fontWeight: 500, fontSize: '20px' }}>
              {projectSite[0]?.credits?.average_price_per_vcu}
            </Typography>
          </Grid>
          <Divider orientation="vertical" flexItem sx={{ mx: 2, borderColor: '#ccc' }} />
          <Grid size={{ xs: 4, sm: 3 }}>
            <Typography sx={{ color: "#666666", fontWeight: 600, fontSize: '16px' }}>
              {'Total VCUs Retired'}
            </Typography>
            <Typography sx={{ color: "#000", fontWeight: 500, fontSize: '20px' }}>
              {projectSite[0]?.credits?.total_vcu_retired}
            </Typography>
          </Grid>
          <Divider orientation="vertical" flexItem sx={{ mx: 2, borderColor: '#ccc' }} />
          <Grid size={{ xs: 4, sm: 2 }}>
            <Typography sx={{ color: "#666666", fontWeight: 600, fontSize: '16px' }}>
              {'VCUs available for Sale'}
            </Typography>
            <Typography sx={{ color: "#000", fontWeight: 500, fontSize: '20px' }}>
              {projectSite[0]?.credits?.vcu_available_for_sale}
            </Typography>
          </Grid>
         
        </Grid>
      </Box>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12 }}>
          <ChartComponent
            chartType="line"
            chartTitle="Estimated VCUs Per Year"
            data={Object.keys(filterCredit?.vcu || {}).map((key) => ({
              name: key,
              value1: Number(filterCredit?.vcu[key as keyof typeof filterCredit.vcu] as any) || 0,
            }))}
            title="VCUs"
            seriesValue1="VCUs"
            yTitle='Year'
          />
        </Grid>
        <Grid size={{ xs: 12 }}>
          {/* <Grid container spacing={2}>
            {chartConfigs.map((config) => (
              <Grid size={{ xs: 6, sm: 4, md: 3 }} key={config.year}>
                <HighchartsReact highcharts={Highcharts} options={config.options} />
              </Grid>
            ))}
          </Grid> */}
          <ChartComponent chartType={'bar'} chartTitle={'Estimated VCUs / Buffer Unit'} data={chartDataBuffer} title='VCUs' seriesValue1='Buffer Unit'
            seriesValue2='Estimated VCUs' yTitle='Year'/>
        </Grid>
        <Grid size={{ xs: 12 }}>
          <ChartComponent chartType={'bar'} chartTitle={'Estimated VCUs /Retired'} data={chartData} title='VCUs' seriesValue1='Estimated VCUs'
            seriesValue2='Estimated Retired VCUs' yTitle='Year'/>
        </Grid>
      </Grid>
    </Box>
  );
};

export default CarbonCredit;